import { formatTradeLogicV2ExitCandidateLabel } from '@/components/TradeLogic/formatTradeLogicV2ExitCandidateLabel';

export const formatStrategyVersionKey = (strategyVersionKey: string | undefined | null): string => {
    if (!strategyVersionKey) return 'None';
    if (strategyVersionKey.length <= 20) return strategyVersionKey;

    return `${strategyVersionKey.slice(0, 8)}…${strategyVersionKey.slice(-8)}`;
};

export const formatHash = (hash: string | null | undefined): string => {
    if (!hash) return 'None';
    if (hash.length <= 24) return hash;

    return `${hash.slice(0, 14)}…${hash.slice(-8)}`;
};

export const formatExitCandidate = (candidate: { candidateId: number | null; candidateHash: string | null }): string =>
    formatTradeLogicV2ExitCandidateLabel({
        exitCandidateHash: candidate.candidateHash,
        exitCandidateId: candidate.candidateId
    });

/** Compact "time since" label for a freshness indicator. Input is whole seconds elapsed. */
export const formatSecondsAgo = (secondsAgo: number): string => {
    if (secondsAgo < 5) return 'just now';
    if (secondsAgo < 60) return `${secondsAgo}s ago`;

    const minutes = Math.floor(secondsAgo / 60);
    if (minutes < 60) return `${minutes}m ago`;

    const hours = Math.floor(minutes / 60);
    if (hours < 24) return `${hours}h ago`;

    return `${Math.floor(hours / 24)}d ago`;
};

export const getCoveragePercent = (withBacktestsCount: number, totalInUniverse: number): number | null =>
    totalInUniverse > 0 ? Math.round((withBacktestsCount / totalInUniverse) * 100) : null;
